<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Add Intern</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <form>
          <div class="panel panel-grey">
            <div class="panel-body">
              <div class="form-horizontal">

                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.first_name" field-name="First name"/>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.last_name" field-name="Last name"/>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.email" field-name="Email"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <ladda-button
                class="btn btn-sm btn-primary"
                type="submit"
                :click="handleAddInternCallback">
                Add Intern
              </ladda-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { notify, http } from 'utils'
import { required, email } from 'vuelidate/lib/validators'
import uniqueEmail from '../../../validators/uniqueEmail'
import FieldInput from '../misc/FieldInput'

export default {
  components: {
    FieldInput
  },

  data () {
    return {
      email: null,
      first_name: null,
      last_name: null
    }
  },

  validations: {
    first_name: { required },
    last_name: { required },
    email: {
      required,
      email,
      uniqueEmail
    }
  },

  methods: {
    handleAddInternCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }
      const payload = {
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name
      }
      return http.post('intern', payload).then((response) => {
        this.$router.push({ name: 'interns.profile.show', params: { id: response.data.id } })
      })
    }
  }
}
</script>
